var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var getIcon = function (hover) {
    var icon = "url(\"data:image/svg+xml,%3Csvg width='128' height='128' viewBox='0 0 128 128' xmlns='http://www.w3.org/2000/svg'%3E%3Ctitle%3Eregular/x%3C/title%3E%3Cpath fill='%23XXXXXX' d='M68.95 63.293l45.25-45.25a2 2 0 0 0 .006-2.832l-2.831-2.831a1.997 1.997 0 0 0-2.832.005l-45.25 45.251-44.544-44.543a2 2 0 0 0-2.83-.006l-2.832 2.831a1.997 1.997 0 0 0 .006 2.831l44.543 44.544-45.25 45.25a2 2 0 0 0-.006 2.832l2.831 2.83a1.997 1.997 0 0 0 2.831-.005l45.25-45.25 45.959 45.957a2 2 0 0 0 2.83.006l2.832-2.831a1.997 1.997 0 0 0-.006-2.831L68.95 63.293z'  fill-rule='evenodd'/%3E%3C/svg%3E\")";
    return icon.replace('XXXXXX', (hover ? '#41a8d2' : '#1588af').replace('#', ''));
};
/** @ignore */
export var colorIndexes = [
    { backgroundColor: '#cccccc', color: '#222222' },
    { backgroundColor: '#41a8d2' },
    { backgroundColor: '#ffd70b' },
    { backgroundColor: '#3dc270' },
    { backgroundColor: '#d43046' },
    { backgroundColor: '#5e4982' },
    { backgroundColor: '#ff8800' },
    { backgroundColor: '#f8b100' },
    { backgroundColor: '#11779c' },
    { backgroundColor: '#53d168' },
    { backgroundColor: '#d1eb58' },
    { backgroundColor: '#a95998' },
    { backgroundColor: '#f59299' },
];
export var tag = {
    alignItems: 'center',
    background: '#666666',
    border: 'none',
    borderRadius: 2,
    boxSizing: 'border-box',
    color: '#ffffff',
    display: 'inline-flex',
    fontSize: 12,
    fontWeight: '400',
    lineHeight: 1,
    padding: 4,
    verticalAlign: 'middle',
};
export var combinators = {
    '& + &': {
        marginLeft: 4,
    },
    '&:first-child': {
        marginLeft: 0,
    },
};
export var positive = __assign(__assign({}, tag), { background: '#3dc270', color: '#ffffff' });
export var negative = __assign(__assign({}, tag), { background: '#c8102e', color: '#ffffff' });
export var warning = __assign(__assign({}, tag), { background: '#ff8800', color: '#ffffff' });
export var pending = __assign(__assign({}, tag), { background: '#ffd70b', color: '#222222' });
export var info = __assign(__assign({}, tag), { background: '#41a8d2', color: '#ffffff' });
export var white = __assign(__assign({}, tag), { background: '#ffffff', color: '#222222' });
export var gray = __assign(__assign({}, tag), { background: '#eaeaea', color: '#666666' });
export var disabled = __assign(__assign({}, tag), { background: '#cccccc' + ' !important', color: '#ffffff' + ' !important', ':hover': {
        cursor: 'not-allowed !important',
    } });
export var pill = __assign(__assign({}, tag), { backgroundColor: '#dff4f8', color: '#1588af' });
export var pillBorder = __assign(__assign({}, pill), { border: '1px solid #1588af' });
export var close = {
    backgroundColor: 'transparent',
    backgroundImage: getIcon(false),
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    border: 'none',
    cursor: 'pointer',
    display: 'inline-block',
    height: 12,
    marginLeft: 4,
    position: 'relative',
    top: 0,
    width: 12,
    ':hover': {
        backgroundImage: getIcon(true),
    },
};
